<template>
  <span class="d-book-submission-min-date">{{ minDiscoveryLaunchDate.duration }} {{ minDiscoveryLaunchDate.type }}</span>
</template>

<script>
import { BOOK_SUBMISSION } from '@d-shared/config';

export default {
  data: () => ({
    minDiscoveryLaunchDate: BOOK_SUBMISSION.minDiscoveryLaunchDate,
  }),
};
</script>
